import { useMemo } from 'react';

import { AdminLabelsV1LabelResourceType } from '@spotify/confidence-graphql';

import { useLabels } from '../useLabels';

export type LabelDefinition = {
  id: string;
  name: string;
  displayName: string;
  description?: string;
  allowedValues: string[];
};

export type UseLabelsForResourceOptions = {
  resourceType: AdminLabelsV1LabelResourceType;
  skip?: boolean;
};

export const useLabelsForResource = ({
  resourceType,
  skip,
}: UseLabelsForResourceOptions) => {
  const filter = `resourceTypes:${resourceType}`;

  const { labels, isLoading, error } = useLabels({
    filter,
    skip,
  });

  const labelDefinitions = useMemo(() => {
    if (!labels) return [];

    return labels.map(label => ({
      id: label.name.replace('labels/', ''),
      name: label.name,
      displayName: label.displayName || label.name.replace('labels/', ''),
      description: label.description ?? undefined,
      allowedValues: label.allowedValues,
    }));
  }, [labels]);

  return {
    labelDefinitions,
    isLoading,
    error,
  };
};
